import { ClientProposition } from "@dune/types";
import { Badge } from "@dune/ui";
import { formatCurrency, formatSimpleDate } from "@dune/utils";
import { ColumnDef } from "@tanstack/react-table";

export const clientPropositionsColumns = (): ColumnDef<ClientProposition>[] => [
	{
		accessorKey: "reference",
		header: "Référence",
		cell: ({ row }) => (
			<div className="font-medium">{row.getValue("reference")}</div>
		),
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			const status = row.original.status;
			return (
				<Badge variant="outline" className="text-xs">
					{status}
				</Badge>
			);
		},
	},
	{
		accessorKey: "productType",
		header: "Type de produit",
		cell: ({ row }) => (
			<div className="text-sm text-gray-600">{row.getValue("productType")}</div>
		),
	},
	{
		accessorKey: "assureurName",
		header: "Assureur",
		cell: ({ row }) => (
			<div className="text-sm">{row.getValue("assureurName")}</div>
		),
	},
	{
		accessorKey: "primeTTC",
		header: "Prime TTC",
		cell: ({ row }) => {
			const primeTTC = row.original.primeTTC;
			return (
				<div className="text-sm font-medium">{formatCurrency(primeTTC)}</div>
			);
		},
	},
	{
		accessorKey: "constructionSite.address",
		accessorFn: (row) => row.constructionSite?.address ?? null,
		header: "Adresse",
		cell: ({ getValue }) => {
			const address = getValue<string | null>();
			return (
				<div className="text-sm text-gray-600">
					{address ?? "Non renseignée"}
				</div>
			);
		},
	},
	{
		accessorKey: "createdAt",
		header: "Créé le",
		cell: ({ row }) => {
			const createdAt = row.original.createdAt;
			return (
				<div className="text-sm text-gray-600">
					{formatSimpleDate(new Date(createdAt))}
				</div>
			);
		},
	},
];
